import useMediaQuery from './useMediaQuery';

function useWindowSize(breakpoint = 768) {
  return useMediaQuery(`(min-width: ${breakpoint}px)`);
}

export default useWindowSize;
